export const formatDieselOrderEmailHTML = (poReqNumber, details) => `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Diesel Supplier Assigned – PO #${poReqNumber}</title>
</head>

<body style="margin:0;padding:0;background:#f0f2f5;font-family:'Segoe UI',Helvetica,Arial,sans-serif;">

  <table width="100%" cellpadding="0" cellspacing="0" style="background:#f0f2f5;padding:32px 16px;">
    <tr>
      <td align="center">

        <table width="600" cellpadding="0" cellspacing="0" style="max-width:600px;width:100%;">

          <tr>
            <td style="background:#1a2332;padding:20px 28px;border-radius:8px 8px 0 0;">
              <table width="100%">
                <tr>
                  <td>
                    <p style="margin:0;font-size:11px;letter-spacing:2px;text-transform:uppercase;color:#8a9bb5;">
                      Diesel Purchase Update
                    </p>
                    <h1 style="margin:4px 0 0;font-size:20px;color:#ffffff;">
                      PO Request #${poReqNumber}
                    </h1>
                  </td>

                  <td align="right">
                    <span style="background:#3b82f6;color:#fff;font-size:11px;font-weight:700;padding:5px 12px;border-radius:4px;">
                      ORDERED
                    </span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <tr>
            <td style="background:#ffffff;padding:28px;border-left:1px solid #e2e6ea;border-right:1px solid #e2e6ea;">

              <p style="margin:0 0 14px;font-size:14px;color:#4a5568;line-height:1.6;">
                Your diesel purchase request has been processed. A supplier has been assigned and is currently on the way to your location.
              </p>
              
              <div style="background:#fffbeb;border-left:4px solid #f59e0b;padding:12px 16px;margin-bottom:24px;">
                <p style="margin:0;font-size:13px;color:#92400e;line-height:1.5;">
                  <strong>Required Action:</strong> Once your refill is complete, please collect the delivery docket from the supplier. Go to your mobile app, navigate to the <strong>Purchase Requisition</strong>, select the <strong>Ordered</strong> tab, and submit the docket photo to complete the delivery request from your end.
                </p>
              </div>

              <table width="100%" cellpadding="0" cellspacing="0" style="margin-bottom:20px;">
                <tr>
                  <td width="50%" style="padding-right:8px;">
                    <p style="margin:0;font-size:10px;color:#8a9bb5;text-transform:uppercase;">SP Name</p>
                    <p style="margin:0;font-size:14px;font-weight:600;color:#1a2332;">${details.spName}</p>
                  </td>

                  <td width="50%" style="padding-left:8px;">
                    <p style="margin:0;font-size:10px;color:#8a9bb5;text-transform:uppercase;">Assigned Supplier</p>
                    <p style="margin:0;font-size:14px;font-weight:600;color:#1a2332;">
                      ${details.supplierName || 'N/A'}
                    </p>
                  </td>
                </tr>
              </table>

              <table width="100%" cellpadding="0" cellspacing="0" style="margin-bottom:20px;">
                <tr>
                  <td width="50%" style="padding-right:8px;">
                    <p style="margin:0;font-size:10px;color:#8a9bb5;text-transform:uppercase;">Requested Litres</p>
                    <p style="margin:0;font-size:14px;font-weight:700;color:#16a34a;">
                      ${details.litres} L
                    </p>
                  </td>

                  <td width="50%" style="padding-left:8px;">
                    <p style="margin:0;font-size:10px;color:#8a9bb5;text-transform:uppercase;">Ordered At</p>
                    <p style="margin:0;font-size:14px;font-weight:600;color:#1a2332;">
                      ${details.orderedAt}
                    </p>
                  </td>
                </tr>
              </table>

              <div style="background:#f7f9fc;border:1px solid #e2e6ea;border-radius:6px;padding:14px 16px;margin-bottom:20px;">
                <p style="margin:0;font-size:10px;color:#8a9bb5;text-transform:uppercase;">
                  Your Current Location
                </p>
                <p style="margin:0;font-size:14px;font-weight:600;color:#1a2332;">
                  ${details.location}
                </p>
              </div>

            </td>
          </tr>

          <tr>
            <td style="background:#f7f9fc;border:1px solid #e2e6ea;border-radius:0 0 8px 8px;padding:16px 28px;">
              <p style="margin:0;font-size:11px;color:#a0aec0;">
                Automated message from Diesel Dispatch System. Please ensure you upload the files promptly after delivery.
              </p>
            </td>
          </tr>

        </table>

      </td>
    </tr>
  </table>

</body>
</html>
`;
